export const bgg = {
  url: 'https://www.boardgamegeek.com/xmlapi2',
};

export const gallery = {
  url: 'https://ve734szkp5.execute-api.eu-central-1.amazonaws.com/production',
  apiKey: process.env.REACT_APP_GALLERY_API_KEY,
};

export const facebookPixel = {
  id: process.env.REACT_APP_FB_PIXEL_ID,
};

export const smartGaming = {
  url: 'https://smart-gaming.it/wp-json/wp/v2',
};

export const alexaEvents = {
  url: 'https://h4j64lgei6.execute-api.eu-west-1.amazonaws.com/default',
  apiKey: process.env.REACT_APP_ALEXA_EVENTS_API_KEY,
};